// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { LPCellInfo } from "./types/liquidity";

// GetLPPositionsResponse returns the LP's own CKB cells plus their ETH pool
// position. ethShares/ethWithdrawable/ethTotalShares are big.Int decimal
// strings (wei / raw shares) — handle as BigInt. ethWithdrawable is the owner's
// claim capped by the pool's free (non-locked) ETH.
@jsonObject()
export default class GetLPPositionsResponse extends PerunMessage {
  @jsonArrayMember(LPCellInfo) ckbCells: LPCellInfo[];
  @jsonMember(String) ethShares: string;
  @jsonMember(String) ethWithdrawable: string;
  @jsonMember(String) ethTotalShares: string;

  constructor(
    ckbCells: LPCellInfo[] = [],
    ethShares = "0",
    ethWithdrawable = "0",
    ethTotalShares = "0",
  ) {
    super();
    this.ckbCells = ckbCells;
    this.ethShares = ethShares;
    this.ethWithdrawable = ethWithdrawable;
    this.ethTotalShares = ethTotalShares;
  }

  messageType(): MessageType {
    return GetLPPositionsResponse;
  }

  messageTypeName(): MessageTypeName {
    return "GetLPPositionsResponse";
  }
}
